/**
 * Enum de pendencias de acesso.
 */
// eslint-disable-next-line import/prefer-default-export
export const accessPending = {
  LICENSE: 'license',
  TEMP_ACCESS: 'temp-access',
};
